import React from 'react';
import { Route, RouteProps } from 'react-router';
import { memoizedNest } from 'utils/nest';

type PropType = RouteProps & {
  wrappers: React.ComponentType[];
};

const WrappedRoute: React.FC<PropType> = ({
  wrappers,
  component: Component,
  ...rest
}) => {
  const Wrapper = memoizedNest(...wrappers);

  return (
    <Route
      render={routeProps =>
        Component && (
          <Wrapper>
            <Component {...routeProps} />
          </Wrapper>
        )
      }
      {...rest}
    />
  );
};

export default WrappedRoute;
